module.exports = __webpack_public_path__ + "static/img/7-1.796ff34.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/joinUs/7-1.png
// module id = PwhF
// module chunks = 15